// TOAST-UX-001: Radix overlays (Dialog / AlertDialog / Sheet) close on any pointer-down outside their content.
// A click on a toast's X (or action button) is "outside", so it used to close the open dialog behind it.
// Compose this into `onInteractOutside` so interactions that start inside the toaster are ignored.
export const isToastInteraction = (event) => {
  const target = event?.detail?.originalEvent?.target || event?.target;
  return !!(target && typeof target.closest === 'function' && target.closest('[data-sonner-toaster]'));
};

export const guardToastOutside = (userHandler) => (event) => {
  if (isToastInteraction(event)) { event.preventDefault(); return; }
  userHandler?.(event);
};
